"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canceledPreviously = exports.exit = exports.appointmentReschedulingPending = exports.appointmentReschedulingFailed = exports.appointmentRescheduling = exports.appointmentRescheduleSuccess = exports.idle = exports.fetchingReasons = exports.confirmationPage = exports.jumpToDate = exports.appointmentRescheduled = exports.rescheduleReason = exports.modificationWindowExpired = exports.fetchAppointmentSuccess = exports.fetchingAppointment = exports.apptTime = exports.newSearch = exports.nextSearch = exports.failedFetchingslots = exports.noResults = exports.fetchAvailableSlots = exports.done = exports.next = exports.failedLoading = exports.fetchProvider = exports.fetchAppointment = exports.alreadyRescheduled = exports.alreadyCanceled = exports.appointmentMissed = exports.modificationBlocked = exports.disabled = exports.routing = exports.reschedule = exports.success = exports.initializing = exports.error = exports.manageAppointment = void 0;
exports.manageAppointment = '@state/MANAGE_APPOINTMENT';
exports.error = '@state/ERROR';
exports.initializing = '@state/INITIALIZING';
exports.success = '@state/SUCCESS';
exports.reschedule = '@state/RESCHEDULE';
exports.routing = '@state/ROUTING';
exports.disabled = '@state/DISABLED';
exports.modificationBlocked = '@state/MODIFICATION_BLOCKED';
exports.appointmentMissed = '@state/APPOINTMENT_MISSED';
exports.alreadyCanceled = '@state/ALREADY_CANCELED';
exports.alreadyRescheduled = '@state/ALREADY_RESCHEDULED';
exports.fetchAppointment = '@state/FETCH_APPOINTMENT';
exports.fetchProvider = '@state/FETCH_PROVIDER';
exports.failedLoading = '@state/FAILED_LOADING';
exports.next = '@state/NEXT';
exports.done = '@state/DONE';
exports.fetchAvailableSlots = '@state/FETCH_AVAILABLE_SLOTS';
exports.noResults = '@state/NO_RESULTS';
exports.failedFetchingslots = '@state/FAILED_FETCHING_SLOTS';
exports.nextSearch = '@state/NEXT_SEARCH';
exports.newSearch = '@state/NEW_SEARCH';
exports.apptTime = '@state/APPT_TIME';
exports.fetchingAppointment = '@state/FETCHING_APPOINTMENT';
exports.fetchAppointmentSuccess = '@state/FETCH_APPOINTMENT_SUCCESS';
exports.modificationWindowExpired = '@state/MODIFICATION_WINDOW_EXPIRED';
exports.rescheduleReason = '@state/RESCHEDULE_REASON';
exports.appointmentRescheduled = '@state/APPOINTMENT_RESCHEDULED';
exports.jumpToDate = '@state/JUMP_TO_DATE';
exports.confirmationPage = '@state/CONFIRMATION_PAGE';
// States for Reason Machine
exports.fetchingReasons = '@state/FETCHING_REASONS';
exports.idle = '@state/IDLE';
exports.appointmentRescheduleSuccess = '@state/RESCHEDULE_SUCCESS';
exports.appointmentRescheduling = '@state/RESCHEDULING_APPOINTMENT';
exports.appointmentReschedulingFailed = '@state/RESCHEDULING_APPOINTMENT_FAILED';
exports.appointmentReschedulingPending = '@state/RESCHEDULING_APPOINTMENT_PENDING';
exports.exit = '@state/EXIT';
exports.canceledPreviously = '@state/CANCELED_PREVIOUSLY';
//# sourceMappingURL=States.js.map